module.exports = __webpack_public_path__ + "d3001c9e4920b1bfc59f65aa787f1847.png";